import type { PolicySpec } from '@reef/schema';
import { SubNav } from '../components/SubNav.tsx';
import { AdminView } from './AdminView.tsx';
import { OperationsView } from './OperationsView.tsx';
import { PolicyView } from './PolicyView.tsx';

/**
 * How the deployment is configured, and the four controls somebody reaches
 * for while it is doing something they did not want.
 *
 * Operations sits here rather than with the reports because its controls
 * change what happens next — the stop switch, the detections — and a screen
 * that changes things belongs with the other screens that do.
 */
export const SETTINGS_SECTIONS = [
  { id: 'policies', label: 'Policies' },
  { id: 'admin', label: 'Admin' },
  { id: 'operations', label: 'Operations' },
] as const;

export function SettingsView({
  section,
  policies,
  isAdmin,
  onSection,
  onPoliciesChanged,
}: {
  section: string;
  policies: PolicySpec[];
  isAdmin: boolean;
  onSection(id: string): void;
  onPoliciesChanged(): void;
}) {
  return (
    <div className="screen">
      <SubNav title="Settings" current={section} onChange={onSection} items={SETTINGS_SECTIONS} />
      {section === 'admin' ? (
        <AdminView isAdmin={isAdmin} />
      ) : section === 'operations' ? (
        <OperationsView isAdmin={isAdmin} />
      ) : (
        <PolicyView policies={policies} isAdmin={isAdmin} onChanged={onPoliciesChanged} />
      )}
    </div>
  );
}
